import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path opacity=\"0.4\" d=\"M21.2501 9.14906C20.7601 8.36906 20.2001 7.66906 19.6201 7.03906L15.8501 10.8091C15.9701 11.1791 16.0401 11.5791 16.0401 11.9991C16.0401 14.2391 14.2301 16.0391 12.0001 16.0391C11.5801 16.0391 11.1801 15.9691 10.8101 15.8491L7.3501 19.3091C8.8101 20.1291 10.3901 20.5591 12.0001 20.5591C13.7801 20.5591 15.5101 20.0391 17.0901 19.0691C18.6701 18.0891 20.0901 16.6591 21.2501 14.8391C22.2501 13.2791 22.2501 10.7191 21.2501 9.14906Z\" fill=\"#212121\"></path><path d=\"M14.0199 9.98062L9.97989 14.0206C9.46989 13.5006 9.13989 12.7806 9.13989 12.0006C9.13989 10.4306 10.4199 9.14062 11.9999 9.14062C12.7799 9.14062 13.4999 9.47062 14.0199 9.98062Z\" fill=\"#212121\"></path><path opacity=\"0.4\" d=\"M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z\" fill=\"#212121\"></path><path d=\"M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z\" fill=\"#212121\"></path><path d=\"M21.7699 2.23086C21.4699 1.93086 20.9799 1.93086 20.6799 2.23086L2.22988 20.6909C1.92988 20.9909 1.92988 21.4809 2.22988 21.7809C2.37988 21.9209 2.56988 22.0009 2.76988 22.0009C2.96988 22.0009 3.15988 21.9209 3.30988 21.7709L21.7699 3.31086C22.0799 3.01086 22.0799 2.53086 21.7699 2.23086Z\" fill=\"#212121\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

import { withDefaults } from 'vue';

  interface IProps {
    color?: string;
    width?: number;
    height?: number;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SlashEyeIcon',
  props: {
    color: {},
    width: {},
    height: {}
  },
  setup(__props: any) {

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
}

})